// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SmartRocketBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M10.352 19.768a1.5 1.5 0 0 1-.949 1.898c-1.483.494-2.305 1.742-2.763 3.117a8.63 8.63 0 0 0-.224.801c.256-.059.526-.132.801-.224 1.375-.458 2.623-1.28 3.117-2.763a1.5 1.5 0 0 1 2.846.948c-.92 2.76-3.207 4.06-5.014 4.661a12.287 12.287 0 0 1-3.379.606l-.1.002a1.5 1.5 0 0 1-1.5-1.5v-.101l.01-.224a12.292 12.292 0 0 1 .597-3.155c.602-1.807 1.901-4.095 4.66-5.014a1.5 1.5 0 0 1 1.898.948Z"
					/>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M26.023 5.978c-1.222-.097-3.637.1-6.133 2.597L12.465 16l3.536 3.535 5.992-5.991.036-.037 1.396-1.396c2.497-2.497 2.694-4.911 2.598-6.133ZM17.629 22.15l3.942-3.943v4.243l-3.235 3.235-.707-3.535Zm-8.025-4.768 5.014 5.014.96 4.794a2.499 2.499 0 0 0 4.218 1.277l4.043-4.042a2.5 2.5 0 0 0 .732-1.768v-7.45l.976-.975c3.634-3.634 3.654-7.371 3.4-9.078l-2.1-2.1c-1.707-.255-5.444-.234-9.079 3.4l-.974.975h-7.45a2.5 2.5 0 0 0-1.768.732l-4.043 4.043a2.5 2.5 0 0 0 1.277 4.22l4.794.958Zm.247-3.01 3.942-3.943H9.552l-3.236 3.236 3.536.707ZM26.847 3.054a2.496 2.496 0 0 1 2.1 2.1l-2.1-2.1Z"
						clipRule="evenodd"
					/>
				</svg>
			}
		</IconContainer>
	);
}
